import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Injectable()
export class TermsConditionsService {
  constructor(private http: HttpClientService) { }

  /**
   * Get Terms & Conditions data from API
   * This is a dummy API call that returns mock data
   * In production, replace this with actual API endpoint
   */
  getTermsConditionsData(): Observable<any> {
    // Simulate API call with delay
    // In production, replace this with: return this.http.get('terms-conditions/data', null, 2);
    
    const mockResponse = {
      status: 'success',
      message: 'Terms and conditions data retrieved successfully',
      data: {
        title: 'AFROPAY – TERMS & CONDITIONS (T&C)',
        lastUpdated: 'Last Updated: 8 December 2025',
        introduction: 'The purpose of these Terms & Conditions ("T&C") is to define the terms under which Afro Pay Company Ltd ("Afro Pay", "we", "us", "our") provides the AfroPay mobile wallet service, including issuance and distribution of electronic money, mobile transactions, bill payments, merchant payments, and international remittances. By downloading, registering for, or using AfroPay, you accept these T&C. If you do not agree, please do not access the AfroPay App. Continued use after any amendments constitutes tacit acceptance of the updated T&C.',
        acceptance: 'By registering for or using AfroPay, you confirm that you: a. Have read and understood these T&C b. Accept and are bound by them c. Can download or print a copy',
        sections: [
          {
            title: 'Definitions',
            content: '',
            points: [
              '"AfroPay Account" - A unique electronic money account associated with the User, accessible via the AfroPay mobile application.',
              '"Electronic Money (E-Money)" - Monetary value issued by Afro Pay, stored electronically, representing a claim on Afro Pay.',
              '"AfroPay Agent" - A service provider authorised by Afro Pay to perform cash-in, cash-out, and onboarding services.',
              '"PIN" - A personal and secret code chosen by the User to authorize AfroPay transactions.',
              '"Beneficiary" - A person designated to receive E-Money or remittance funds.',
              '"KYC" - Know-Your-Customer verification required under Gambian law.',
              '"Transaction" - Any movement of funds carried out via AfroPay.'
            ]
          },
          {
            title: 'Registration & Use of AfroPay',
            content: '',
            points: [
              '3.1 Mandatory Identification - Use of AfroPay requires valid identification as required by The Gambia\'s laws and CBG regulations.',
              '3.2 Verification - AfroPay may verify your identity, request additional documents, refuse or suspend accounts, or decline transactions that appear non-compliant.',
              '3.3 Screening - By using AfroPay, you authorize Afro Pay to conduct AML/CTF checks and verify information with third-party providers.',
              '3.4 Wallet Limits - a. KYC 1 (After Onboarding): DXX,XXX balance; DXX,XXX monthly inflow b. KYC2 (After identity verification): DXXX,XXX balance; DX,XXX,XXX monthly inflow Limits may change per regulation.'
            ]
          },
          {
            title: 'AfroPay Services',
            content: '',
            points: [
              '4.1 Cash Services - a. Cash-In b. Cash-Out through authorized Agents.',
              '4.2 Domestic Transactions - a. Wallet transfers b. Airtime/data purchases c. Bill payments d. Merchant (QR/POS) payments',
              '4.3 Remittances - AfroPay may support inbound and outbound international remittances through approved partners.'
            ]
          },
          {
            title: 'AfroPay Accounts',
            content: 'Opening an AfroPay wallet:',
            points: [
              'a. Does not create a bank account',
              'b. Provides access to E-Money, not deposit protection',
              'c. Requires PIN creation and identity verification'
            ]
          },
          {
            title: 'Transactions',
            content: '',
            points: [
              '6.1 Authorization - All transactions must be authenticated using your PIN or other approved method.',
              '6.2 Fees - Fees will be displayed before confirmation and deducted from your wallet.',
              '6.3 User Responsibility - You are responsible for accuracy of beneficiary and transaction details.',
              '6.4 Right to Reject or Delay Transactions - AfroPay may reject or delay a transaction if: a. Limits are exceeded b. Funds unavailable c. Fraud is suspected d. Required by regulators'
            ]
          },
          {
            title: 'Security & Fraud Prevention',
            content: '',
            points: [
              'Your PIN must be kept strictly confidential.',
              'You are responsible for all transactions completed before your account is blocked after you report loss or compromise.'
            ]
          },
          {
            title: 'Account Closure & Suspension',
            content: '',
            points: [
              '8.1 User Request - You may close your account at any time.',
              '8.2 AfroPay Suspension - AfroPay may close or restrict your account for: a. Fraud suspicion b. AML/CTF concerns c. Invalid KYC d. Breach of these T&C e. Regulatory obligations'
            ]
          },
          {
            title: 'App Availability',
            content: 'AfroPay strives to be available 24/7, but service disruptions may occur due to:',
            points: [
              'a. Network issues',
              'b. System upgrades',
              'c. Regulatory intervention',
              'AfroPay is not liable for disruptions beyond its control.'
            ]
          },
          {
            title: 'Error Resolution & Cancellation',
            content: '',
            points: [
              'You may dispute a transaction within 180 days.',
              'Refunds may not be possible if the beneficiary has already been paid.',
              'If the transaction is pending, cancellations may be made within 30 minutes.'
            ]
          },
          {
            title: 'Limitation of Liability',
            content: 'Afro Pay is not liable for:',
            points: [
              'a. Indirect, consequential, or punitive damages',
              'b. User errors in beneficiary details',
              'c. System failures beyond its control',
              'Maximum liability is limited to: a. The disputed transaction amount or b. The applicable fees whichever is lower.'
            ]
          },
          {
            title: 'Indemnity',
            content: 'You agree to indemnify Afro Pay for losses arising from:',
            points: [
              'a. Breach of these T&C',
              'b. Misuse of AfroPay',
              'c. Providing false information',
              'd. Unauthorized access due to your negligence'
            ]
          },
          {
            title: 'Amendments',
            content: '',
            points: [
              'AfroPay may amend these T&C at any time.',
              'Changes take effect upon posting unless the law requires prior notice.'
            ]
          },
          {
            title: 'Electronic Communications',
            content: 'You consent to receiving:',
            points: [
              'a. Alerts',
              'b. Notices',
              'c. Statements',
              'd. Updates',
              'via SMS, email, or in-app notifications.'
            ]
          },
          {
            title: 'Governing Law & Dispute Resolution',
            content: '',
            points: [
              'These T&C are governed by the laws of The Gambia.',
              'Disputes shall be resolved amicably first, then—if unresolved—submitted to Gambian courts.'
            ]
          },
          {
            title: 'Data Protection',
            content: '',
            points: [
              'AfroPay processes personal data in accordance with its Privacy Policy, which forms part of these T&C.',
              'AfroPay may share personal data with: a. Regulated partners b. Cloud service providers c. CBG / FIU d. Law enforcement',
              'AfroPay does not sell user data.'
            ]
          }
        ],
        contactEmail: 'legal@afropay.com',
        contactPhone: '+234 (0) 800 000 0000'
      }
    };

    // Simulate network delay (1 second)
    return Observable.of(mockResponse).delay(1000);
    
    // Production API call (uncomment when ready):
    // return this.http.get('terms-conditions/data', null, 2);
  }
}




// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/terms-conditions/terms-conditions.service.ts